import { Button } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'

interface PurchaseCTAProps {
  onCTAClicked: () => void
  className?: string
}

const PurchaseCTA = ({ onCTAClicked, className }: PurchaseCTAProps) => {
  const { t } = useTranslation('@mc/next')

  return (
    <Button
      as='a'
      href={paths.enterpriseCart}
      className={className}
      data-testid='self-serve-cta'
      onClick={onCTAClicked}
    >
      {t('enterpriseSelfServe.about.cta')}
    </Button>
  )
}

export default PurchaseCTA
